import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


export interface Dentist {
  id: string;
  name: string;
  cpf: string;
  birth_date: string;
  email: string;
  cellphone: string;
  cro: string;
  status: number;
}

export async function fetchDentists(
  includeInactive = false,
  complete = false,
  nameLike?: string,
  page = 1,
  pageSize = 20
): Promise<Dentist[]> {
  const params = new URLSearchParams({
    include_inactive: includeInactive.toString(),
    complete: complete.toString(),
    page: page.toString(),
    page_size: pageSize.toString(),
  });

  if (nameLike) params.append('name_like', nameLike);

  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dentists/?${params.toString()}`);

  if (!response.ok) {
    throw new Error('Erro ao buscar dentistas');
  }

  const data = await response.json();
  return data.items ?? data;
}

export interface CreateDentistData {
  name: string;
  cpf: string;
  birth_date: string;
  email: string;
  cellphone: string;
  cro: string;
}

export async function createDentist(data: CreateDentistData): Promise<Dentist> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dentists`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao criar dentista');
  }

  return response.json();
}

export async function updateDentist(id: string, data: CreateDentistData): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dentists/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao atualizar dentista');
  }
}

export async function activateDentist(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dentists/${id}/activate`, {
    method: 'PATCH',
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao ativar dentista');
  }
}

export async function inactivateDentist(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dentists/${id}/inactivate`, {
    method: 'PATCH',
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao inativar dentista');
  }
}

export async function deleteDentist(id: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/dentists/${id}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao deletar dentista');
  }
}